module.exports = __webpack_public_path__ + "img/grand-cancun-room-2.e4ac9223.jpg";